export const contactsData = {
    email: 'semegnnyx@gmail.com',
    phone: '+251705109046',
    address: 'Addis Ababa, Ethiopia',

    sheetAPI: ''  
}